import { apiGet, apiPost } from "../client";
import type {
  ColumnConfigResponseApi,
  SaveColumnConfigRequestApi,
} from "../models/columnConfig";

export async function getColumnConfigs(): Promise<ColumnConfigResponseApi> {
  return apiGet<ColumnConfigResponseApi>("column-config");
}

export async function saveColumnConfigs(
  request: SaveColumnConfigRequestApi,
): Promise<void> {
  return apiPost<void>("column-config", request);
}
